exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tag.class {\n    position: unset !important;\n}\n\n.key {\n    margin-left: 10;\n}\n\n.padding-top-11 {\n    padding-top: 11;\n}\n\n.navbar-edcast a {\n    font-family: 'Open Sans';\n    font-size: 20px;\n    color: #26273b;\n    text-decoration: none solid rgb(38, 39, 59);\n    text-align: center;\n    margin: 0 16;\n    cursor: pointer;\n}\n\n.navbar-edcast {\n    text-align: center;\n    background: white;\n    padding: 13;\n}\n\n.edcast-underlined {\n    border-bottom: 4px solid #38b6a0;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/workflow-new/course/course-container/course-container.component.css
// module id = 816
// module chunks = 0